import { useIsBannerHidden } from 'hooks/useIsBannerHidden'
import NotificationBanner from '../Header/HeaderBanners/NotificationBanner'
import { useLocation } from 'react-router-dom'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

const ROUTES_WITH_NO_NOTIFICATION_BANNER: Array<string> = [
  '/:regionCode/corporate-events/:eventId',
  '/:regionCode/corporate-events/:eventId/faq',
  '/:regionCode/corporate-events/:eventId/other-activities',
  '/:regionCode/corporate-events/:eventId/flights',
  '/:regionCode/corporate-events/:eventId/accommodation',
  '/:regionCode/corporate-events/:eventId/things-to-know',
  '/:regionCode/corporate-events/:eventId/register',
]

const HELP_NOTIFICATION_BANNER_ROUTES: Array<string> = [
  '/:regionCode/terms-and-conditions',
  '/:regionCode/account/my-escapes',
  '/:regionCode/account/my-escapes/order/:orderId',
]

function NotificationBannerRoutes() {
  const isHidden = useIsBannerHidden('notificationBanner')
  const location = useLocation()
  const pathname = location.pathname

  if (isHidden) {
    return null
  }

  if (matchLocaleAwarePath(pathname, { path: ROUTES_WITH_NO_NOTIFICATION_BANNER })) {
    return null
  }

  if (matchLocaleAwarePath(pathname, { path: HELP_NOTIFICATION_BANNER_ROUTES })) {
    return <NotificationBanner slug="help-with-banner" />
  }

  return <NotificationBanner />
}

export default NotificationBannerRoutes
